enum FacetType {
  TRAVEL_START_DATE = 'TRAVELSTARTDATE',
  PACKAGE_CODE = 'PACKAGECODE'
}

export default FacetType;
